import React, {ReactElement} from 'react';
import {useMoneyLeft} from 'ui/utils/core';
import {Failure} from 'components/Failure';
import {Success} from 'components/Success';
import {Section} from 'components/Section';
import {UpdateBudget} from 'components/ProceedOptions';

const Proceed = (): ReactElement => (
  <Section>
    <UpdateBudget />
  </Section>
);

const Message = (): ReactElement => {
  const savedMoney = useMoneyLeft();
  return savedMoney <= 0 ? <Failure /> : <Success />;
};

export const Results = (): ReactElement => (
  <div data-test='results'>
    <Message />
    <Proceed />
  </div>
);
